export const HTTP_STATUS_SUCCESS_CODES = {
  HTTP_STATUS_OK: 200,
  HTTP_STATUS_CREATED: 201,
  HTTP_STATUS_ACCEPTED: 202,
  HTTP_STATUS_NON_AUTHORITATIVE_INFORMATION: 203,
  HTTP_STATUS_NO_CONTENT: 204,
  HTTP_STATUS_RESET_CONTENT: 205,
  HTTP_STATUS_PARTIAL_CONTENT: 206,
  HTTP_STATUS_MULTI_STATUS: 207,
  HTTP_STATUS_ALREADY_REPORTED: 208,
  HTTP_STATUS_IM_USED: 226,
};

export const HTTP_STATUS_FAILURE_CODES = {
  HTTP_STATUS_NOT_ACCEPTABLE: 406,
  HTTP_STATUS_UNAUTHORIZED: 401,
};

/**
|                       | message                | status_code | http_status_code |
| --------------------- | ---------------------- | ----------- | ---------------- |
| AUTH_TOKEN_MISSING    | Auth Token Missing     | 1           | 400              |
| INVALID_AUTH_TOKEN    | Invalid Auth Token     | 2           | 400              |
| ACCESS_TOKEN_MISSING  | Access Token Missing   | 3           | 400              |
| INVALID_JWT_TOKEN     | Invalid JWT Token      | 4           | 401              |
| ACCESS_TOKEN_EXPIRED  | Access Token Expired   | 5           | 401              |
| UNKNOWN_USER          | Unknown User           | 6           | 400              |
| REFRESH_TOKEN_EXPIRED | Refresh Token Expired  | 7           | 401              |
| REFRESH_TOKEN_MISSING | Refresh Token Missing  | 8           | 401              |
| INVALID_PLATFORM      | Platform not allowed   | 9           | 401              |
| INVALID_CREDENTAILS   | Operations not allowed | 10          | 401              |
 */
export const AUTH_STATUS_CODES = {
  AUTH_TOKEN_MISSING: 1,
  INVALID_AUTH_TOKEN: 2,
  ACCESS_TOKEN_MISSING: 3,
  INVALID_JWT_TOKEN: 4,
  ACCESS_TOKEN_EXPIRED: 5,
  UNKNOWN_USER: 6,
  REFRESH_TOKEN_EXPIRED: 7,
  REFRESH_TOKEN_MISSING: 8,
  INVALID_PLATFORM: 9,
  INVALID_CREDENTAILS: 10,
};
